export default __webpack_public_path__ + "static/media/imageUpload.1ca3ccbe.svg";